import { AppBar, Dialog, DialogActions, DialogContent, FormControl, FormHelperText, IconButton, TextField, Toolbar, Tooltip, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React from 'react';
import StadiumButton from '../../customComponents/button/StadiumButton';
import { ITrapComment, TrapCommentHelper } from '../../../types/model/trap/trapComment';
import GeneralFunctions from '../../../store/general/functions';
import moment from 'moment';
import { TransitionProps } from '@material-ui/core/transitions';
import { IUserSession } from '../../../types/model/user';

interface IAddTrapCommentProps {
    fullWidth ?: boolean;
    maxWidth ?: 'xs' | 'sm' | 'md' | 'lg' | false;
    fullScreen ?: boolean;
    transition ?: React.ForwardRefExoticComponent<TransitionProps & React.RefAttributes<unknown>>;

    open : boolean;
    onClose ?: () => void;
    session : IUserSession;
    trapId : string;
}

interface IAddTrapCommentState {
    comment : string;

    isLoading : boolean;
}

export default class AddTrapCommentDialog extends React.PureComponent<IAddTrapCommentProps, IAddTrapCommentState> {
    constructor(props : IAddTrapCommentProps) {
        super(props);
        this.state = {
            comment: '',
            isLoading: false,
        };
    }

    public componentDidUpdate(prevProps : Readonly<IAddTrapCommentProps>) : void {
        if (!prevProps.open && this.props.open) {
            this.setState({
                comment: '',
                isLoading: false,
            });
        }
    }

    private onCommentChange = (event : React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            comment: event.currentTarget.value,
        });
    };

    public onClose = () => {
        if (!this.props.onClose) return;
        this.props.onClose();
    };

    private readonly onSubmit = (event : React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        this.save();
    };

    private save = async () => {
        const { comment } = this.state;
        const { trapId, session } = this.props;

        const result : ITrapComment = {
            id: '',
            createdBy: session.firebaseUser.uid,
            createdByEmployee: session.user.employeeNumber,
            createdByName: session.user.name,
            createdOn: moment.utc().valueOf(),
            updatedBy: session.firebaseUser.uid,
            updatedByEmployee: session.user.employeeNumber,
            updatedByName: session.user.name,
            updatedOn: moment.utc().valueOf(),
            comment,
            trapId: trapId,
            date: moment.utc().valueOf(),
            type: 'website',
        };

        try {
            this.setState({
                isLoading: true,
            });

            await TrapCommentHelper.save(result);

            this.onClose();
        } catch (ex) {
            GeneralFunctions.generalShowErrorSnackbar('Error saving comment.', ex);
        } finally {
            this.setState({
                isLoading: false,
            });
        }
    };

    public render = () => {
        const { transition, maxWidth, fullWidth, fullScreen, open } = this.props;
        const { comment, isLoading } = this.state;
        return (
            <Dialog
                open={open}
                TransitionComponent={transition}
                transitionDuration={500}
                maxWidth={maxWidth}
                fullScreen={fullScreen}
                fullWidth={fullWidth}
                aria-labelledby='tooltip-dialog-title'
                aria-describedby='tooltip-description'>
                <AppBar className='fdr posr aic jcc' position='static'>
                    <Toolbar className={'fdr flx1 aic jcc'}>
                        <Typography variant='h5' color='inherit'>
                            Add Comment
                        </Typography>
                        <span className='flx1' />
                        <Tooltip title='Close'>
                            <div>
                                <IconButton color='inherit' onClick={this.onClose} aria-label='Close'>
                                    <Close />
                                </IconButton>
                            </div>
                        </Tooltip>
                    </Toolbar>
                </AppBar>
                <form autoComplete='off' onSubmit={this.onSubmit} className='fdc flx1 hfill'>
                    <DialogContent className='fdc'>
                        <div className={'flx2 aife p5 mb10 pr20'} style={{ marginTop: '16px' }}>
                            <FormControl fullWidth>
                                <TextField
                                    value={comment}
                                    onChange={this.onCommentChange}
                                    aria-describedby='comment'
                                    label='Website Comment'
                                    required
                                    multiline
                                    error={!comment}
                                    autoFocus
                                />
                                {
                                    !comment &&
                                    <FormHelperText error>Required</FormHelperText>
                                }
                            </FormControl>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <StadiumButton disabled={isLoading} variant='text' onClick={this.onClose} color='primary' autoFocus>
                            CANCEL
                        </StadiumButton>
                        <StadiumButton disabled={isLoading} type='submit' variant='contained' color='primary'>
                            OK
                        </StadiumButton>
                    </DialogActions>
                </form>
            </Dialog>
        );
    };
}
